import { useQuery } from "@tanstack/react-query";
import { getFreezeApplications, FreezeApplication } from "@/http/freezeApplicationsApi";
import { getFreezeApplicationsQueryKey } from "@/utils/queryKeys";
import { useAuth } from "@/contexts/AuthContext";
import { useClub } from "@/contexts/ClubContext";

export const useGetFreezeApplicationsQuery = (params?: {
  page?: number;
  pageSize?: number;
  enabled?: boolean;
}) => {
  const { authPhone } = useAuth();
  const { selectedClubId } = useClub();
  const { page = 1, pageSize = 20, enabled = true } = params || {};

  return useQuery<FreezeApplication[]>({
    queryKey: [
      ...getFreezeApplicationsQueryKey(),
      { page, pageSize, phone: authPhone, clubId: selectedClubId },
    ],
    queryFn: async () => {
      const response = await getFreezeApplications(authPhone, {
        page,
        pageSize,
        clubId: selectedClubId,
      });
      return response.data.data;
    },
    enabled: enabled && !!authPhone && !!selectedClubId,
  });
};
